import { NgModule } from "@angular/core";
import { LoggedInGuard } from 'src/app/guards/logged-in.guard';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from '../pages.component';
import { TemplateListComponent } from './template-list/template-list.component';

const routes: Routes = [
  {
    path: 'Templates',
    component: PagesComponent,
    canActivate: [LoggedInGuard],
    children: [
      { path: '', component: TemplateListComponent, canActivate: [LoggedInGuard] }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class TemplatesRoutingModule { }